// Whether the analytics notice has been read.
//
// **A notice, not a choice**, and the storage says so: it remembers that
// somebody closed it, and closing it changes nothing about what is collected.
// That is the honest shape for what this is — page analytics are on for
// everybody, so a banner with an "allow" button would be offering a decision
// that is not on the table. The thing a player *can* decide is whether their
// games are sent, and that has its own dialog with two buttons and a setting
// under the gear.
//
// Remembered per browser and for good. A banner that comes back every visit is
// one people learn to look past, which defeats the point of having said it.

const KEY = "factory-chess:analytics-notice";

const storage = (): Storage | null => {
  try {
    return window.localStorage;
  } catch {
    // Private browsing, a blocked origin, or no DOM. A notice that cannot be
    // remembered is shown again, which is the safe way round for a disclosure.
    return null;
  }
};

/** Has it been closed? False when storage is unavailable, so it is shown. */
export function noticeSeen(): boolean {
  try {
    return storage()?.getItem(KEY) === "seen";
  } catch {
    return false;
  }
}

/** Remember that it was closed. */
export function markNoticeSeen(): void {
  try {
    storage()?.setItem(KEY, "seen");
  } catch {
    // Losing the dismissal costs one more banner, which is not worth a throw
    // on the screen the game opens on.
  }
}
